import ApiService from "./ApiService";

export async function apiGetItemData<T>() {
  return ApiService.fetchData<T>({
    url: `/onlineOrder/menu`,
    method: "get",
  });
}
